export default __webpack_public_path__ + "static/media/HDTX_LKTT 2022.83cad2cb.pdf";